import { render, staticRenderFns } from "./ZipCodeAreaList.vue?vue&type=template&id=2309ca40&scoped=true&"
import script from "./ZipCodeAreaList.vue?vue&type=script&lang=js&"
export * from "./ZipCodeAreaList.vue?vue&type=script&lang=js&"
import style0 from "./ZipCodeAreaList.vue?vue&type=style&index=0&id=2309ca40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2309ca40",
  null
  
)

export default component.exports